import axios from "api/axios";
import { urlEncode } from "api/api-utils";

const api = {
  getEmissionsTotal({ year, dimensionItemIds }, accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/insights/total?${dimensionItemIds}&year=${year}`, config).then(({ data }) => data);
  },

  getSupplierOverview({ years, categories, dataQuality, scope }, accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios
      .get(
        `/insights/suppliers?categories=${urlEncode(categories)}&years=${urlEncode(years)}&dataQuality=${urlEncode(dataQuality)}&scope=${urlEncode(scope)}`,
        config
      )
      .then(({ data }) => data);
  },

  getSupplierEngagementReports({ years, supplierId }, accessToken) {
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios
      .get(`/insights/suppliers/engagement?years=${urlEncode(years)}&supplierId=${urlEncode(supplierId)}`, config)
      .then(({ data }) => data);
  },
};

export { api as EmissionsInsightsApi };
